import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { Badge, Button, CircularProgress } from "@material-ui/core";
import { Send, Add } from "@material-ui/icons";
import * as S from "./styles";
import ThumbPreview from "./ThumbPreview";
import BigPlayButton from "video-react/lib/components/BigPlayButton";
import { useTranslation } from "react-i18next";

export default function ShowVideos({
  videos,
  onSubmit,
  loading,
  addNewVideos,
  handleRemove,
  selectVideoPreview,
  selectedVideo,
}) {
  const { t } = useTranslation();

  return (
    <S.Container>
      <S.PreviewPlayer>
        <Player
          playsInline
          src={videos[selectedVideo]?.file}
          fluid={false}
          width="80%"
          height="100%"
        >
          <BigPlayButton position="center" />
        </Player>
      </S.PreviewPlayer>

      <S.PreviewContainer>
        <S.PreviewList>
          {videos.map((video, index) => (
            <ThumbPreview
              key={`${video.name}${index}`}
              selected={index == selectedVideo}
              thumbnail={video.file}
              onClick={() => selectVideoPreview(index)}
              removeVideo={() => handleRemove(index)}
            />
          ))}
          <S.AddNewVideo>
            <Add style={{ fontSize: 38 }} />

            <input
              type="file"
              accept="video/*"
              hidden
              multiple
              onChange={addNewVideos}
            />
          </S.AddNewVideo>
        </S.PreviewList>

        <S.Actions>
          <Badge color="secondary" badgeContent={videos.length}>
            <Button
              color="primary"
              variant="contained"
              component="label"
              onClick={onSubmit}
              disabled={videos.length == 0}
              style={{ height: 50, borderRadius: 50 }}
              startIcon={loading ? <CircularProgress /> : <Send />}
            >
              {t("Chat:video_attachment.sendButton")}
            </Button>
          </Badge>
        </S.Actions>
      </S.PreviewContainer>
    </S.Container>
  );
}
